import { useState } from "react";
import { CreatePrTab } from "./IacEligibility/CreatePrTab";
import { PrListingTab } from "./IacEligibility/PrListingTab";
import "./IacEligibility/iac-eligibility.css";

type IacTab = "create" | "listing";

const TABS: { id: IacTab; label: string }[] = [
  { id: "create", label: "Create New PR" },
  { id: "listing", label: "PR Listing" },
];

export function IacEligibilityEngineView() {
  const [activeTab, setActiveTab] = useState<IacTab>("create");

  return (
    <div className="iac-engine">
      <div className="iac-engine__content">
        <p className="iac-engine__eyebrow">Purchase Order</p>
        <h2 className="iac-engine__title">IAC Eligibility Recommendation Engine</h2>

        <div className="iac-engine__tabs" role="tablist" aria-label="IAC eligibility engine">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={activeTab === tab.id}
              className={`iac-engine__tab${activeTab === tab.id ? " is-active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {activeTab === "create" && <CreatePrTab />}
        {activeTab === "listing" && <PrListingTab />}
      </div>
    </div>
  );
}
